<template>
  <div>
    <el-row type="flex" align="middle" justify="space-between">
      <el-col :span="12">
        <div class="page-title">評估詳情</div>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="info" @click="onEditButton">編輯評估</el-button>
      </el-col>
    </el-row>
    <div class="page-box">
      <vue-dividing-line title="年級信息"></vue-dividing-line>
      <el-row class="page-row-list">
        <el-col :span="12"> 年級：{{detail.gradeName}} </el-col>
        <el-col :span="12"> 語言 :{{detail.lang | language}} </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"> 描述：{{detail.name}} </el-col>
        <el-col :span="12"> 發佈時間：{{detail.createdAt | formatDateTime }} </el-col>
      </el-row>
      <vue-dividing-line title="評估題目"></vue-dividing-line>
      <el-table :data="detail.topicQuestions" style="width: 100%;">
        <el-table-column prop="topicNumber" label="課題編號"> </el-table-column>
        <el-table-column prop="practiseNumber" label="練習編號"> </el-table-column>
        <el-table-column prop="questionNumber" label="題目編號"> </el-table-column>
        <el-table-column prop="topicScope" label="課題範圍(島)"> 
          <template slot-scope="{row}">
                  <span>{{row.topicScope | scope}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getAssessmentDetail } from "@/api/assessment";
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detail: {}
    }
  },
  created(){
    this.getAssessmentDetail()
  },
  methods:{
    onEditButton() {
      let path = `/evaluate/${this.id}/edit`
      this.resolveRouter(path)
    },
    getAssessmentDetail(){
      getAssessmentDetail(this.id).then((v)=>{
         this.detail = v.data
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 10px;
  background-color: #fff;
  margin-top: 20px;
}
</style>